<template>
  <div>
    <div>{{ noRecordsMessage }}</div>
    <button
      v-if="noRecordsButtonLabel && noRecordsButtonAction"
      class="btn btn-sm btn-outline-success mt-3"
      @click="noRecordsButtonAction"
    >
      <i class="fa fa-plus"></i>
      {{ noRecordsButtonLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'NoRecordsFound',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    noRecordsMessage: {
      type: String,
      default: 'No records found to display in the table.'
    },
    noRecordsButtonLabel: {
      type: String,
    },
    noRecordsButtonAction: {
      type: Function,
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/NoRecordsFound.vue